<template>
  <div class="weather_box">
   
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.weather_box {
    width: 50%;
    height: 10%;
}
</style>